import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getCompanyName } from 'modules/playbook/selectors'
import { setIndustry } from 'modules/playbook/actions'
import { getDemoRequestProductName, getDemoRequestValueProp, getDemoRequestIndustry } from 'modules/playbook/selectors'
import IndustryStep from 'layouts/OnboardingPlaybookDemoRequestStep/IndustryStep'

const mapStateToProps = (state) => {
  return {
    companyName: getCompanyName(state),
    productName: getDemoRequestProductName(state),
    valueProp: getDemoRequestValueProp(state),
    industry: getDemoRequestIndustry(state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setIndustry
  }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(IndustryStep)


// WEBPACK FOOTER //
// ./src/containers/OnboardingPlaybook/DemoRequestSteps/Industry/index.js